/**
 * @file: useVehicleSystemModules.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { kVehicleSystemModulesKey } from '@euler/functions/constants';
import { asyncStorageSubjectForKey$ } from '@euler/functions/useAsyncStorage';
import { VehicleSystemModule } from '@euler/model/entity';
import { useServiceFactory } from '@euler/services/factory';
import { onErrorIgnore } from '@euler/utils';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { useEffect } from 'react';

const systemModules$ = asyncStorageSubjectForKey$<VehicleSystemModule[]>(
  kVehicleSystemModulesKey,
  undefined,
  { storageType: 'file' },
);

export const useVehicleSystemModules = () => {
  const { inventoryService } = useServiceFactory();
  const [systemModules, setSystemModules] = useBehaviorSubject(systemModules$);

  useEffect(() => {
    inventoryService
      .getVehicleSystemModules()
      .then(res => {
        setSystemModules(res);
      })
      .catch(onErrorIgnore);
  }, [inventoryService, setSystemModules]);

  return systemModules;
};
